import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// SERVICES
import {
  LessonsService,
  PaymentsService,
  GiftsService,
  CouponsService,
  OffersService,
} from '@app/services';

// PIPES
import { PipesModule } from '@commons/pipes';

// COMMONS DIRECTIVES
import { DirectivesModule } from '@commons/directives';

// COMMONS
import { CommonsComponentsModule } from '@commons/components';

// COMPONENTS
import { AchatsPage } from './achats.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DirectivesModule,
    PipesModule,
    CommonsComponentsModule,
    RouterModule.forChild([
      {
        path: '',
        component: AchatsPage,
      },
    ]),
  ],
  declarations: [AchatsPage],
})
export class AchatsPageModule {}
